import Api from './Api';

const getCategory = () => {
  return Api().get(`/categories/`);
};
const getCategoryById = (id) => {
  return Api().get(`/categories/${id}`);
};
export { getCategory, getCategoryById };
